import styled, { css } from 'styled-components';
import {
  createButtonTransition,
  getButtonThemeColor,
  specialButtonStyle,
  frostedButtonStyle,
} from 'components/Button';
import ButtonBase from 'components/ButtonBase';
import { headlinerGradient } from 'styles/gradient';
import { getThemeColor } from 'utils/styled';
import { StyleProps } from './types';

const SPECIAL_GRADIENT_ANGLE = 135;

const defaultVariantStyle = css<StyleProps>`
  color: ${getButtonThemeColor('main')};
  transition: ${createButtonTransition(['color'])};

  * {
    height: 100%;
    width: 100%;
  }

  &[data-hovered='true']:not([disabled]) {
    color: ${getButtonThemeColor('hover')};
  }
`;

const specialVariantStyle = css<StyleProps>`
  ${specialButtonStyle};

  background-image: ${headlinerGradient(SPECIAL_GRADIENT_ANGLE)};

  &:before {
    background-image: ${headlinerGradient(SPECIAL_GRADIENT_ANGLE + 180)};
  }
`;

const adornmentVariantStyle = css`
  height: 100%;
  width: auto;

  * {
    height: 100%;
    width: auto;
  }

  &,
  &[data-hovered='true'] {
    color: ${getThemeColor('d5')};
  }

  &:active:not([disabled]),
  &:active:not([disabled]):after {
    box-shadow: none;
  }

  &,
  &[disabled] {
    opacity: 1;
  }
`;

const solidVariantStyle = css`
  background-color: ${getButtonThemeColor('main')};
  color: ${getThemeColor('l2')};
  transition: ${createButtonTransition(['background-color'])};

  &[data-hovered='true']:not([disabled]) {
    background-color: ${getButtonThemeColor('hover')};
  }
`;

export const Root = styled(ButtonBase)<StyleProps>`
  align-items: center;
  background-color: transparent;
  border-radius: 50%;
  display: inline-flex;
  height: ${({ $size }) => ($size === 'large' ? '50px' : '30px')};
  justify-content: center;
  letter-spacing: normal;
  padding: 0;
  position: relative;
  width: ${({ $size }) => ($size === 'large' ? '50px' : '30px')};

  &:after {
    border-radius: inherit;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  ${(props) => {
    switch (props.$variant) {
      case 'default':
        return defaultVariantStyle;

      case 'special':
        return specialVariantStyle;

      case 'adornment':
        return adornmentVariantStyle;

      case 'solid':
        return solidVariantStyle;
      case 'frosted':
        return frostedButtonStyle;

      default:
        return undefined;
    }
  }}
`;
